import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { concatWithDot } from 'helpers/string';

import { GLOBAL_FIELD_NAMES, globalPrefix } from '../../Global/form';

export const MarketOverview = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.OVERVIEW,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_OVERVIEW.MARKET_CUSTOMERS,
  );

  return (
    <Box>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          section={FOR_BANK_SECTIONS.OVERVIEW}
          locked={!canAccess}
          title={t('overviewTitle')}
          badgeText={t('overview.market.title')}
        />
      </FormSectionCard>
      {/* 0.3.1 */}
      <FormSectionCard
        title={t('overview.market.targetMarket')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_MARKET)}
        disabled={!canAccess}
      >
        <TextInputControl
          multiline
          control={control}
          id="overview.market.targetMarket"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_MARKET)}
          disabled={!canAccess}
          minRows={4}
          maxLength={1000}
        />
      </FormSectionCard>
      {/* 0.3.2 */}
      <FormSectionCard
        title={t('overview.market.targetAudience')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_AUDIENCE)}
        disabled={!canAccess}
      >
        <TextInputControl
          multiline
          control={control}
          id="overview.market.targetAudience"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_AUDIENCE)}
          disabled={!canAccess}
          minRows={4}
          maxLength={1000}
        />
      </FormSectionCard>
      {/* 0.3.3 */}
      <FormSectionCard
        title={t('overview.market.sellingChannels')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_CHANNELS)}
        disabled={!canAccess}
      >
        <TextInputControl
          multiline
          control={control}
          id="overview.market.sellingChannels"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_CHANNELS)}
          disabled={!canAccess}
          minRows={4}
          maxLength={1000}
        />
      </FormSectionCard>
      {/* 0.3.4 */}
      <FormSectionCard
        title={t('overview.market.mainCompetitors')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_COMPETITORS)}
        disabled={!canAccess}
      >
        <TextInputControl
          multiline
          control={control}
          id="overview.market.mainCompetitors"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_COMPETITORS)}
          disabled={!canAccess}
          minRows={4}
          maxLength={1000}
        />
      </FormSectionCard>
    </Box>
  );
};
